import { FULFILLMENTS } from '../constants';
import { STATUS } from '../constants/status';

// RegExp
const ORDER_ID_REGEX = /^[WwCc][a-zA-Z0-9]\d{8}$/;
const ORDER_ID_REGEX_PARTIAL = /^[WwCc][a-zA-Z0-9]?\d{0,8}$/;
const INSTORE_ORDER_ID_REGEX = /^H\d{4}-?\d+$/i;
const INSTORE_ORDER_ID_REGEX_PARTIAL = /^[hH]\d{0,33}$/i;
const EMAIL_ID_REGEX = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
const PHONE_NUMBER_REGEX = /^\d{3}-\d{3}-\d{4}$/;
const UNDEFINED_REGEX = '/^(\\d+)$/';

// validators
export const isEmailIdValid = (emailId: string) => {
  if (emailId === null || emailId === undefined) return false;
  return EMAIL_ID_REGEX.test(emailId);
};

export const isOrderIdValid = (orderId: string) => ORDER_ID_REGEX.test(orderId);

export const isOrderIdValidPartial = (orderId: string) =>
  ORDER_ID_REGEX_PARTIAL.test(orderId);

export const isInstoreOrder = (orderId: string) =>
  orderId[0] === 'H' || orderId[0] === 'h';

export const isInstoreOrderIdValid = (orderId: string) =>
  INSTORE_ORDER_ID_REGEX.test(orderId);

export const isInstoreOrderIdValidPartial = (orderId: string) =>
  INSTORE_ORDER_ID_REGEX_PARTIAL.test(orderId);

export const isPhoneNumberValid = (phoneNumber: string) =>
  PHONE_NUMBER_REGEX.test(phoneNumber);

export const isNotUndefined = (val: Object) => val !== UNDEFINED_REGEX;

export const isStatusCanceledOrReturned = (statusCode: number) =>
  statusCode === STATUS.CANCELED ||
  statusCode === STATUS.RETURNED ||
  statusCode === STATUS.RETURN_IN_PROGRESS;

export const isEligibleApplianceItem = (item: Object) => {
  const { fulfillment, currentQuantity } = item;
  if (currentQuantity < 1) {
    return false;
  }
  return fulfillment
    ? fulfillment.fulfillmentMethod ===
        FULFILLMENTS.FULFILLMENT_METHOD_APPLIANCE
    : false;
};
